export const actionKey = '@@GROUPS';

//# sourceMappingURL=constants.js.map